/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AgentCompatibilityRadarScores from './AgentCompatibilityRadarScores';

/**
 * The AgentCompatibilityRadar model module.
 * @module model/AgentCompatibilityRadar
 * @version 1.0.0
 */
class AgentCompatibilityRadar {
    /**
     * Constructs a new <code>AgentCompatibilityRadar</code>.
     * @alias module:model/AgentCompatibilityRadar
     */
    constructor() { 
        
        AgentCompatibilityRadar.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentCompatibilityRadar</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentCompatibilityRadar} obj Optional instance to populate.
     * @return {module:model/AgentCompatibilityRadar} The populated <code>AgentCompatibilityRadar</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentCompatibilityRadar();

            if (data.hasOwnProperty('total_score')) {
                obj['total_score'] = ApiClient.convertToType(data['total_score'], 'Number');
            }
            if (data.hasOwnProperty('scores')) {
                obj['scores'] = AgentCompatibilityRadarScores.constructFromObject(data['scores']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentCompatibilityRadar</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentCompatibilityRadar</code>.
     */
    static validateJSON(data) {
        // validate the optional field `scores`
        if (data['scores']) { // data not null
          AgentCompatibilityRadarScores.validateJSON(data['scores']);
        }

        return true;
    }


}



/**
 * 5軸スコアの単純平均
 * @member {Number} total_score
 */
AgentCompatibilityRadar.prototype['total_score'] = undefined;

/**
 * @member {module:model/AgentCompatibilityRadarScores} scores
 */
AgentCompatibilityRadar.prototype['scores'] = undefined;






export default AgentCompatibilityRadar;

